module.exports = __webpack_public_path__ + "static/why-trust-us-doctor-8859762523257eeb08d6c72e2745d15e.png";